/* eslint-disable @typescript-eslint/unbound-method */
import { Component, type TemplateRef, ViewChild, DestroyRef, inject, type OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../shared/services/error.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  FormControl,
  FormGroupDirective,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { Nav } from '../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ChangePassword } from '../../shared/models/change-password';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountDetail } from '../../shared/models/account-detail';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UserProfile } from '../../shared/models/user-profile';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { BiometricsService } from '../../shared/services/biometrics.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { catchError, EMPTY, finalize } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { EncryptionService } from '../../shared/services/encryption.service';
import {
  BiometryErrorType,
  type CheckBiometryResult,
} from '@aparajita/capacitor-biometric-auth/dist/esm/definitions.js';
import { type ApiError } from '../../shared/models/api-error';

@Component({
  selector: 'app-update-login-info',
  imports: [
    MatDividerModule,
    MatButtonModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    PageHeaderComponent,
    RouterModule,
    NotificationComponent,
    MatSlideToggleModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatDialogModule,
  ],
  templateUrl: './update-login-info.component.html',
  styleUrl: './update-login-info.component.scss',
})
export class UpdateLoginInfoComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  pageLabels: any = {};
  pageReady = false;
  changePasswordForm!: FormGroup;
  passwordVisible = false;
  confirmPasswordVisible = false;
  hasOneSpecialCharacter = false;
  hasOneNumber = false;
  hasLessthanSevenChar = false;
  charNotAllowed = false;
  apiErrors: ApiError[] = [];
  formErrorMessage = '';
  changePasswordModel!: ChangePassword;
  accountDetail!: AccountDetail;
  userProfile?: UserProfile;
  headerData = new PageHeader();
  passwordSpecialCharacterText = '(can\'t be ()+=-[]\\;,./{}|":<>`~)';
  passwordAriaLabelText = `password requirements must have at least one number
    at least one special character and cannnot be left parentheseis right parenthesis
    plus sign equal sign minus sign open brace close brace
    back slash semi colon comma period forward slash open bracket close bracket
    pipe perenthesis colon less than angle greater than angle back tick tilde and at least 7-12 characters long`;

  pageName = Nav.UpdateLoginInfo;
  bioForm!: FormGroup;
  encryptedCreds: any = null;
  showBiometricOption = false;
  showBioWarningMessage = false;
  @ViewChild('bioPopup') bioPopup!: TemplateRef<any>;
  @ViewChild('bioEnrollPopup') bioEnrollPopup!: TemplateRef<any>;
  @ViewChild('bioCancelPopup') bioCancelPopup!: TemplateRef<any>;

  constructor(
    private readonly bioS: BiometricsService,
    private readonly utils: UtilService,
    private readonly cms: CmsService,
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly error: ErrorService,
    private readonly formBuilder: FormBuilder,
    private readonly storage: StorageService,
    private readonly account: AccountService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
    private readonly encryptS: EncryptionService,
  ) {}

  ngOnInit(): void {
    // Initialize state from storage
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
    this.encryptedCreds = this.storage.getLocal(StorageEnum.EncryptedCreds);
    this.bioForm = this.formBuilder.group({
      bio: [!!(this.encryptedCreds && this.bioS.bioInfo.UsernameMatch)],
    });

    this.cms
      .getContent('oas-change-password', 'OAS Change Password')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        const bioTypeText = this.bioS.getAvailableBiometricsText();
        const replacedBioText = JSON.stringify(data).replace(/{BIOTYPE}/g, bioTypeText);
        this.pageLabels = JSON.parse(replacedBioText);
        this.headerData.Message = this.pageLabels.changePasswordHeaderText;
        this.seoS.setSeoTags(data.seo);
        this.changePasswordForm = this.getPwForm();
        this.showBiometricOption = this.bioS.bioInfo.Platform !== 'web' && this.bioS.bioInfo.BioAvailable;
        this.showBioWarningMessage = !!(this.encryptedCreds && !this.bioS.bioInfo.UsernameMatch);
        this.pageReady = true;
        this.utils.hideSpinner();
      });
  }

  getPwForm(): FormGroup {
    return this.formBuilder.group({
      password: [
        '',
        [Validators.required, Validators.maxLength(12), Validators.minLength(7), this.validatePassword.bind(this)],
      ],
      confirmPassword: [
        '',
        [
          Validators.required,
          Validators.maxLength(12),
          Validators.minLength(7),
          this.validateConfirmPassword.bind(this),
        ],
      ],
    });
  }

  onSubmit(formDir: FormGroupDirective): void {
    this.formErrorMessage = '';
    if (this.changePasswordForm.valid) {
      this.utils.showSpinner();
      this.apiErrors = this.storage.getSession(StorageEnum.GlobalVars).apiErrors;
      // Handle form submission
      const userPassword: string = this.password.value;
      this.changePasswordModel = new ChangePassword();
      this.changePasswordModel.NewPassword = userPassword;
      this.changePasswordModel.AccountId = this.accountDetail.AccountNumber;
      this.changePasswordModel.UserName = this.userProfile?.UserName;

      this.account
        .ChangePassword(this.changePasswordModel)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          finalize(() => {
            this.changePasswordModel.NewPassword = '';
            this.changePasswordModel.UserName = '';
            this.changePasswordModel.AccountId = '';
            formDir.resetForm(this.getPwForm().value);
            this.utils.hideSpinner();
          }),
          catchError(() => {
            this.setErrorData();
            void this.router.navigateByUrl(Nav.ErrorPage);
            return EMPTY;
          }),
        )
        .subscribe(() => {
          formDir.resetForm(this.getPwForm().value);

          // Check if user has stored biometrics
          if (this.bioS.bioInfo.UsernameMatch) {
            // Set flag to update biometrics on next login with the username
            const username = this.userProfile?.UserName ?? '';
            this.storage.setLocal(StorageEnum.PasswordUpdatedNeedsBioUpdate, username);
            // Display message instructing user to log in again to update biometrics
            this.notifi.addNotification(
              this.pageLabels.bioPasswordUpdatedNotification,
              NotificationType.Postnotification,
              this.pageName,
            );
          } else {
            // Show standard password updated message
            this.notifi.addNotification(
              this.pageLabels.changePasswordSuccessText,
              NotificationType.Postnotification,
              this.pageName,
            );
          }
        });
    } else {
      // Mark all controls as touched to trigger validation messages
      this.changePasswordForm.markAllAsTouched();
      this.showFormErrorLabel();
    }
  }

  bioSubmit(): void {
    // have to add a check to see if bio is avail and print is registered
    const bioValue = this.bioForm.get('bio')?.value;
    this.encryptedCreds = this.storage.getLocal(StorageEnum.EncryptedCreds);
    if (bioValue) {
      this.bioS
        .checkBioObs()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((bioData: CheckBiometryResult) => {
          switch (bioData.code) {
            case BiometryErrorType.biometryNotEnrolled:
              this.bioS.handleError(bioData, this.pageName);
              this.bioForm.get('bio')?.setValue(false);
              this.utils.hideSpinner();
              return;
            case BiometryErrorType.none:
              break;
            default:
              // For other errors, don't proceed
              this.bioS.handleError(bioData, this.pageName);
              return;
          }

          if (!this.encryptedCreds) {
            this.openEnrollDialog();
          } else if (this.encryptedCreds && !this.bioS.bioInfo.UsernameMatch) {
            // user that didnt set up bio wants to set up bio
            this.openDialog();
          }
        });
    } else {
      if (this.encryptedCreds && this.bioS.bioInfo.UsernameMatch) {
        this.openCancelDialog();
      }
    }
  }

  openDialog(): void {
    const dialogConfig = {
      disableClose: true,
      panelClass: 'gs-dialog',
    };
    const dialogRef = this.dialog.open(this.bioPopup, dialogConfig);

    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result) {
          this.storage.setSession(StorageEnum.BioRedirectRoute, Nav.UpdateLoginInfo);
          void this.router.navigateByUrl(Nav.BioTerms);
        } else {
          this.bioForm.get('bio')?.setValue(false);
        }
      });
  }

  openEnrollDialog(): void {
    const dialogConfig = {
      disableClose: true,
      panelClass: 'gs-dialog',
    };
    const dialogRef = this.dialog.open(this.bioEnrollPopup, dialogConfig);

    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result) {
          this.storage.setSession(StorageEnum.BioRedirectRoute, Nav.UpdateLoginInfo);
          void this.router.navigateByUrl(Nav.BioTerms);
        } else {
          this.bioForm.get('bio')?.setValue(false);
        }
      });
  }

  openCancelDialog(): void {
    const dialogConfig = {
      disableClose: true,
      panelClass: 'gs-dialog',
    };
    const dialogRef = this.dialog.open(this.bioCancelPopup, dialogConfig);

    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result) {
          // remove biometrics
          this.storage.removeLocal(StorageEnum.EncryptedCreds);
          this.bioS.bioInfo.UsernameMatch = false;
          this.notifi.addNotification(
            this.pageLabels.changeBioSuccessText,
            NotificationType.Postnotification,
            this.pageName,
          );
          this.bioForm.get('bio')?.setValue(false);
        } else {
          this.bioForm.get('bio')?.setValue(true);
        }
      });
  }

  get password(): FormControl {
    return this.changePasswordForm.get('password') as FormControl;
  }

  get confirmPassword(): FormControl {
    return this.changePasswordForm.get('confirmPassword') as FormControl;
  }

  validatePassword(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    const passwordPatternOneNumberCheck = /\d/;
    if (!passwordPatternOneNumberCheck.test(value)) {
      this.hasOneNumber = true;
    } else {
      this.hasOneNumber = false;
    }

    const passwordPatternOneSpecialCharCheck = /[*_!@#$%^&?]/;
    if (!passwordPatternOneSpecialCharCheck.test(value)) {
      this.hasOneSpecialCharacter = true;
    } else {
      this.hasOneSpecialCharacter = false;
    }

    if (value.length < 7 || value.length > 12) {
      this.hasLessthanSevenChar = true;
    } else {
      this.hasLessthanSevenChar = false;
    }

    const passwordPatternCharNotAllowedCheck = /[()+=\-[\]\\';,./{}|":<>~\s]/;
    if (passwordPatternCharNotAllowedCheck.test(value)) {
      this.charNotAllowed = true;
    } else {
      this.charNotAllowed = false;
    }

    const passwordPatternOneNumber = /\d/;
    if (!passwordPatternOneNumber.test(value)) {
      return { pwMeetsRequirments: true };
    }

    const passwordPatternOneLetter = /[a-zA-Z]/;
    if (!passwordPatternOneLetter.test(value)) {
      return { pwMeetsRequirments: true };
    }

    const passwordPatternCharNotAllowed = /[()+=\-[\]\\';,./{}|":<>~\s]/;
    if (passwordPatternCharNotAllowed.test(value)) {
      return { pwMeetsRequirments: true };
    }

    const passwordPatternOneSpecialChar = /[*_!@#$%^&?]/;
    if (!passwordPatternOneSpecialChar.test(value)) {
      return { pwMeetsRequirments: true };
    }
    return null;
  }

  validateConfirmPassword(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    const passwordPatternOneNumber = /\d/;
    if (!passwordPatternOneNumber.test(value)) {
      return { confirmPwMeetsRequirments: true };
    }

    const passwordPatternOneLetter = /[a-zA-Z]/;
    if (!passwordPatternOneLetter.test(value)) {
      return { confirmPwMeetsRequirments: true };
    }

    const passwordPatternCharNotAllowed = /[()+=\-[\]\\';,./{}|":<>~\s]/;
    if (passwordPatternCharNotAllowed.test(value)) {
      return { confirmPwMeetsRequirments: true };
    }

    const passwordPatternOneSpecialChar = /[*_!@#$%^&?]/;
    if (!passwordPatternOneSpecialChar.test(value)) {
      return { confirmPwMeetsRequirments: true };
    }

    return null;
  }

  confirmPasswordMatch(): void {
    const password = this.changePasswordForm.get('password');
    const confirmedPassword = this.changePasswordForm.get('confirmPassword');
    if (password && confirmedPassword) {
      const passwordValue = this.changePasswordForm.get('password')?.value;
      const confirmPasswordValue = this.changePasswordForm.get('confirmPassword')?.value;
      if (passwordValue === confirmPasswordValue && passwordValue.length > 0 && confirmPasswordValue.length > 0) {
        confirmedPassword.setErrors(null);
      } else if (passwordValue.length > 0 && confirmPasswordValue.length > 0) {
        if (passwordValue !== confirmPasswordValue) {
          confirmedPassword.setErrors({ passwords2DontMatch: true });
        }
      }
    }
  }

  togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  toggleConfirmPasswordVisibility(): void {
    this.confirmPasswordVisible = !this.confirmPasswordVisible;
  }

  showFormErrorLabel(): void {
    this.formErrorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    if (this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  setErrorData(): void {
    // we will pass none for error code since we are not mapping
    // error codes for change password service
    this.error.setErrorData('none', this.pageLabels.passwordChangeErrorData);
  }
}
